<a bw-anchor-legacy [prefixIconName]="'arrow_left'" (click)="goBack()" color="var(--secondary-text)" anchorStyle="text-large-regular"><span class="hidden-mobile">Back</span></a>
